import { render } from "./ResellersBills.vue?vue&type=template&id=15ca7d37&scoped=true"
import script from "./ResellersBills.vue?vue&type=script&lang=js"
export * from "./ResellersBills.vue?vue&type=script&lang=js"

import "./ResellersBills.vue?vue&type=style&index=0&id=15ca7d37&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend_tr\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ca7d37"]])

export default __exports__